import { render, staticRenderFns } from "./HomeBase.vue?vue&type=template&id=4e0161ae&scoped=true"
import script from "./HomeBase.vue?vue&type=script&lang=js"
export * from "./HomeBase.vue?vue&type=script&lang=js"
import style0 from "./HomeBase.vue?vue&type=style&index=0&id=4e0161ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0161ae",
  null
  
)

export default component.exports